import { Typography } from "@mui/material";
import { useState } from "react";
import { useSubGroups } from "../../../shared/hooks/useItemsData";
import SubGroupItem from "./SubGroupItem";

export default function SubGroupList({ parentItem, onClick }) {
    const { data } = useSubGroups(parentItem ? parentItem.id : null);
    const [activeSubGroup, setActiveSubGroup] = useState(null);

    const handleClick = (subGroup) => {
        onClick(subGroup);
        setActiveSubGroup(subGroup.id);
    };
    return (
        <>
            <div className={"Header__Title"}>
                <div onClick={handleClick}>
                    {parentItem ? parentItem.name : ""}
                </div>
                <div onClick={handleClick}>SubCategories</div>
            </div>
            <div className="ItemsList">
                {data && data.length > 0 ? (
                    data.map((item) => (
                        <div
                            key={
                                parentItem.name +
                                "_" +
                                item.name +
                                "_SubGroupItem"
                            }
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                marginLeft: "5px",
                                marginRight: "5px",
                            }}
                        >
                            <SubGroupItem
                                active={activeSubGroup === item.id}
                                subGroup={item}
                                onClick={handleClick}
                            />
                            <span
                                style={{
                                    fontSize: "10px",
                                    fontWeight: "700",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {item.name}
                            </span>
                        </div>
                    ))
                ) : (
                    <Typography variant="body2">
                        No subcategories found
                    </Typography>
                )}
            </div>
        </>
    );
}
